export * from './thumbs.component';
